$(document).ready(function () {
   // usp slider
   var uspSlider = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplaySpeed: 3000,
      autoplay: true,
      mobileFirst: true,
      // prevArrow:
      //    '<button type="button" class="prev-arrow slick-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 13L1 7L7 1" stroke="black"/></svg></button>',
      // nextArrow:
      //    '<button type="button" class="next-arrow slick-arrow"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L1 13" stroke="black"/></svg></button>',
      responsive: [
         {
            breakpoint: 992,
            settings: 'unslick',
         },
      ],
   };
   var winUsp = $(window);
   var sliderUsp = $('.js-mb-usp-slider-content');

   winUsp.on('load resize', function () {
      if (winUsp.width() < 992) {
         sliderUsp.not('.slick-initialized').slick(uspSlider);
      } else if (sliderUsp.hasClass('slick-initialized')) {
         sliderUsp.slick('unslick');
      }
   });

   // header
   $('.js-hamburger-icon').click(function () {
      $('.js-mb-nav').addClass('mb-show');
      $('body').addClass('mb-scroll-hidden');
   });
   $('.js-close-icon').click(function () {
      $('.js-mb-nav').removeClass('mb-show');
      $('body').removeClass('mb-scroll-hidden');
   });
   $(document).mouseup(function (e) {
      var container = $('.js-mb-nav');
      if (!container.is(e.target) && container.has(e.target).length === 0) {
         container.removeClass('mb-show');
         $('body').removeClass('mb-scroll-hidden');
      }
   });

   // popup toggle
   $('.js-popup').each(function () {
      const toggleHelper = () => {
         if (window.innerWidth < 992) {
            $(this)
               .find('.js-popupTrigger')
               .off('mouseenter')
               .off('mouseleave')
               .on('click', () => {
                  $(this).find('.js-popupContent').toggleClass('active');
               });
         } else {
            $(this)
               .find('.js-popupTrigger')
               .off('click')
               .on('mouseenter', () => {
                  $(this).find('.js-popupContent').addClass('active');
               })
               .on('mouseleave', () => {
                  $(this).find('.js-popupContent').removeClass('active');
               });
         }
      };

      toggleHelper();
      window.addEventListener('resize', toggleHelper);
   });

   // featured slider
   $('.js-featured-slider').slick({
      slidesToShow: 6,
      centerMode: false,
      speed: 6000,
      slidesToScroll: 1,
      arrows: false,
      swipe: false,
      draggable: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      infinite: true,
      autoplaySpeed: 0,
      autoplay: true,
      cssEase: 'linear',
      responsive: [
         {
            breakpoint: 1501,
            settings: {
               slidesToShow: 4,
            },
         },
         {
            breakpoint: 991,
            settings: {
               slidesToScroll: 5,
               // speed: 8000,
            },
         },
         {
            breakpoint: 600,
            settings: {
               slidesToShow: 3,
               // speed: 8000,
            },
         },
         {
            breakpoint: 400,
            settings: {
               slidesToShow: 2,
               speed: 4000,
            },
         },
      ],
   });

   //  video controller
   initVideoControl();
   function initVideoControl() {
      const videoWrapperArray = Array.from(document.querySelectorAll('.js-video'));
      if (videoWrapperArray.length > 0) videoWrapperArray.forEach(playPauseController);

      function playPauseController(videoWrapper) {
         const btnToggle = videoWrapper.querySelector('.js-videoControl');
         const videoPlayer = videoWrapper.querySelector('.js-videoPlayer');

         btnToggle.addEventListener('click', function () {
            if (videoPlayer.paused) {
               videoPlayer.play();
               videoPlayer.setAttribute('controls', 'controls');
            } else {
               videoPlayer.pause();
               videoPlayer.removeAttribute('controls');
            }
         });

         videoPlayer.addEventListener('play', function () {
            btnToggle.classList.remove('active');
         });
         videoPlayer.addEventListener('pause', function () {
            btnToggle.classList.add('active');
         });
      }
   }

   // reviews slider
   $('.js-reviews-slider').slick({
      slidesToShow: 1,
      centerMode: false,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed: 5000,
      adaptiveHeight: false,
   });

   //  tiktok slider
   // initMobileOnlySlider('.js-tiktok-slider', {
   //    slidesToShow: 2,
   //    centerMode: false,
   //    slidesToScroll: 1,
   //    arrows: true,
   //    dots: false,
   //    responsive: [
   //       {
   //          breakpoint: 991,
   //          settings: {
   //             slidesToShow: 3,
   //          },
   //       },
   //       {
   //          breakpoint: 750,
   //          settings: {
   //             slidesToShow: 2,
   //          },
   //       },
   //       {
   //          breakpoint: 550,
   //          settings: {
   //             slidesToShow: 1,
   //          },
   //       },
   //    ],
   // });

   if ($('.js-tiktok-slider').length > 0) {
      $('.js-tiktok-slider').slick({
         slidesToShow: 4,
         centerMode: false,
         slidesToScroll: 1,
         arrows: true,
         dots: false,
         responsive: [
            {
               breakpoint: 991,
               settings: {
                  slidesToShow: 3,
               },
            },
            {
               breakpoint: 750,
               settings: {
                  slidesToShow: 2,
               },
            },
            {
               breakpoint: 550,
               settings: {
                  slidesToShow: 1,
               },
            },
         ],
      });
   }
   //  end tiktok slider

   // text reviews slider
   $('.js-textReviews-slider').slick({
      slidesToScroll: 1,
      slidesToShow: 3,
      arrows: true,
      dots: true,
     autoplay: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      autoplaySpeed: 2000,
      centerMode: false,
      responsive: [
         {
            breakpoint: 991,
            settings: {
               slidesToShow: 3,
            },
         },
         {
            breakpoint: 750,
            settings: {
               slidesToShow: 2,
            },
         },
         {
            breakpoint: 550,
            settings: {
               slidesToShow: 1,
            },
         },
      ],
   });

   // faq accordion
   new Accordion('.js-faq-accordion', {
      duration: 400,
      showMultiple: false,
   });

   AOS.init();
});

// helpers
function initMobileOnlySlider(elSelector, sliderConfig) {
   function initSlider() {
      $(elSelector).slick(sliderConfig);
   }
   if (window.innerWidth < 991) {
      initSlider();
   }

   $(window).resize(function () {
      if (window.innerWidth < 991) {
         if (!$(elSelector).hasClass('slick-initialized')) {
            initSlider();
         }
      } else {
         if ($(elSelector).hasClass('slick-initialized')) {
            $(elSelector).slick('unslick');
         }
      }
   });
}


// 23-04-2024 js start
$(document).ready(function () {
   $('.mb-tiktok__card .mb-tiktok__caption .mb-tiktok__desc').Cuttr({
      //options here
      truncate: 'characters',
      length: 60,
      readMore: true,
      readMoreText: 'Read More',
      readLessText: 'Read Less',
      readMoreBtnTag: 'a',
      readMoreBtnPosition: 'inside'
   });
});
// 23-04-2024 js end

/* Footer Links PopUp start */
$('.mb-footer__list-link.mb-footer-popup-enable').fancybox({
   baseClass: 'footer-links-popup',
});
/* Footer Links PopUp end */


/* Weight Loss Chart JS */

$(document).ready(function () {

   function calculateDataPoints(percentageList, weight, weeks, goalWeight) {
      const dataPoints = [];

      for (let i = 0; i < percentageList.length; i++) {
         const percentage = percentageList[i];
         const value = weight - ((percentage / 100) * weight);
         const formattedValue = Number.isInteger(value) ? value.toFixed(0) : value.toFixed(2);

         // If the value is less than or equal to the goal weight, stop adding further points
         if (value <= goalWeight) {
            dataPoints.push({
               x: weeks[i],
               y: goalWeight,
               label: `${goalWeight} lbs`
            });
            break; // Stop after goal weight is reached
         }

         dataPoints.push({
            x: weeks[i],
            y: value,
            label: `${formattedValue} lbs`
         });
      }

      return dataPoints;
   }

   function findGoalWeek(dataPoints, goalWeight) {
      let maxWeek = null;

      for (let i = 0; i < dataPoints.length; i++) {
         if (dataPoints[i].y <= goalWeight) {
            maxWeek = dataPoints[i].x; // Return the week number
         }
      }
      // Return the maximum week number found, or a default value if no week meets the goalWeight
      return maxWeek !== null ? maxWeek : dataPoints[dataPoints.length - 1].x;
   }

   if (localStorage.getItem("formData")) {
      const formData = JSON.parse(localStorage.getItem("formData"));
      const currentWeight = formData.weight;
      const goalWeight = formData.weightGoal;
      const ctx = document.getElementById('chart1');
      const weeks = ["0", "6", "8", "12", "16", "20", "24", "36", "48", "60", "72", "84"];
      const tirzepatidePercentageList = [0, 3, 6, 8, 10, 12, 15, 18, 19, 20, 21, 26];
      const semaglutidePercentageList = [0, 2, 4, 5, 7, 9, 11, 13, 15, 16];
      const goalWeightData = weeks.map(week => ({ x: parseFloat(week), y: goalWeight })); // Ensure that x-values are exact

      const userName = formData['firstName'];


      $(document).find('.js-userName').text(userName);
      $(document).find('.js-goal-weight').text(goalWeight);
      $(document).find('.js-desired-weight').text(currentWeight - goalWeight);
      $(document).find('.js-current-weight').text(currentWeight);
      $(document).find('.js-weight-count').text(currentWeight - goalWeight);
      // Calculate the weekly weight loss data
      const tirzepatideData = calculateDataPoints(tirzepatidePercentageList, currentWeight, weeks, goalWeight);
      const semaglutideData = calculateDataPoints(semaglutidePercentageList, currentWeight, weeks, goalWeight);
      // Find the week when the goal weight is reached
      const tirzepatideGoalWeek = findGoalWeek(tirzepatideData, goalWeight);
      const semaglutideGoalWeek = findGoalWeek(semaglutideData, goalWeight);

      // Set the js-weekData text to show the week number
      $(document).find('.js-weekData').text(`${tirzepatideGoalWeek}`);

      const customLabelPlugin = {
         id: 'customLabelPlugin',
         afterDatasetsDraw: function (chart, easing) {
            const ctx = chart.ctx;

            chart.data.datasets.forEach(function (dataset, datasetIndex) {
               const meta = chart.getDatasetMeta(datasetIndex);

               if (!meta.hidden) {
                  meta.data.forEach(function (element, index) {
                     const data = dataset.data[index];
                     if (data.label && index != 0) {
                        ctx.fillStyle = dataset.borderColor; // Color of the labels
                        // ctx.font = '12px Arial'; // Font size and style 
                        ctx.textAlign = 'center';
                        ctx.textBaseline = 'bottom';
                        const position = element.tooltipPosition();
                        
                        const screenWidth = window.innerWidth;
                        if (screenWidth < 767) {
                           ctx.font = '12px Arial';  // Smaller font size on small screens
                        } else if (screenWidth < 2000) {
                           ctx.font = '15.7px Arial';  // medium font on width < 2000 screens
                        } else {
                           ctx.font = '18px Arial'; // Larger font on bigger screens
                        }  
                        ctx.fillText(data.label, position.x - dataset.labelDisplayXOffset, position.y - dataset.labelDisplayYOffset); // Position the label above the data point
                     }

                  });
               }


               if (!meta.hidden && dataset.label.includes('Goal Weight')) {
                  // Calculate the middle position of the goal weight line for displaying the label only once
                  const goalWeightLinePoints = meta.data;
                  const middleIndex = Math.floor(goalWeightLinePoints.length / 2);
                  const middlePoint = goalWeightLinePoints[middleIndex];
                  const lastPoint = goalWeightLinePoints[goalWeightLinePoints.length - 1]; // Last point on the goal weight line

                  if (middlePoint) {
                     ctx.fillStyle = 'rgba(162, 72, 87, 0.8)'; // Color for the goal weight label
                     // ctx.font = 'bold 16px Arial'; // Font size and style
                     const screenWidth = window.innerWidth;
                     if (screenWidth < 767) {
                        ctx.font = 'bold 12px Arial';  // Smaller font size on small screens
                     } else if (screenWidth < 2000) {
                        ctx.font = 'bold 15.7px Arial';  // medium font on width < 2000 screens
                     } else {
                        ctx.font = 'bold 18px Arial'; // Larger font on bigger screens
                     }
                      ctx.textAlign = 'center';  
                      ctx.textBaseline = 'bottom';

                     const position = lastPoint.tooltipPosition();
                      if (screenWidth < 767) {
                       ctx.fillText(`${goalWeight} lbs Goal Weight`, position.x - 45, position.y - 6); // Place the label above the dashed line 
                      }
                      else {
                       ctx.fillText(`${goalWeight} lbs Goal Weight`, position.x - 80, position.y - 6); // Place the label above the dashed line
                      }
                  }
               }
            });
         }
      }

      const chartBackgroundPlugin = {
         id: 'chartBackgroundPlugin',
         beforeDraw: (chart) => {
            const ctx = chart.ctx;
            ctx.save();
            ctx.strokeStyle = "rgba(255, 255, 255)";
            ctx.lineWidth = 2;
            ctx.strokeRect(chart.chartArea.left, chart.chartArea.top, chart.chartArea.right - chart.chartArea.left, chart.chartArea.bottom - chart.chartArea.top);
            ctx.fillStyle = 'rgba(242, 242, 242, 1)'; // Background color and transparency
            ctx.fillRect(
               chart.chartArea.left,
               chart.chartArea.top,
               chart.chartArea.right - chart.chartArea.left,
               chart.chartArea.bottom - chart.chartArea.top
            );
            ctx.restore();
         }
      };
      const startingWeightLabelPlugin = {
         id: 'startingWeightLabel',
         afterDraw: function (chart) {
            const ctx = chart.ctx;
            const chartArea = chart.chartArea;

            ctx.save();
            // ctx.font = 'bold 10px Arial'; // Set font style for the label
            const screenWidth = window.innerWidth;
            if (screenWidth < 767) {
               ctx.font = 'bold 12px Arial';  // Smaller font size on small screens
            } else if (screenWidth < 2000) {
               ctx.font = 'bold 15.7px Arial';  // medium font on width < 2000 screens
            } else {
               ctx.font = 'bold 18px Arial'; // Larger font on bigger screens
            }
            ctx.fillStyle = 'rgba(0, 0, 0, 0.8)'; // Set text color

            // Position the label at the top-left corner
            const startingWeight = chart.data.datasets[0].data[0].y.toFixed(0); // Get starting weight value
            ctx.fillText(`Starting Weight`, chartArea.left + 35, chartArea.top + 12); // Adjust position as needed

            ctx.restore();
         }
      };


      const dashedLinePlugin = {
         id: 'dashedLinePlugin',
         beforeDatasetsDraw: function (chart, args, options) {
            const ctx = chart.ctx;
            const yScale = chart.scales.y;
            const xScale = chart.scales.x;

            // Get the y-coordinate for the goal weight
            const goalY = yScale.getPixelForValue(goalWeight);

            // Define where to start drawing (slightly before the first point)
            const startX = xScale.left - 8; // Extend the dashed line before the x-axis
            const endX = xScale.getPixelForValue(weeks[0]);

            // Save the current context
            ctx.save();

            // Set dashed line properties
            ctx.setLineDash([10, 5]);
            ctx.strokeStyle = 'rgba(162, 72, 87, 0.8)';
            ctx.lineWidth = 1;

            // Draw the dashed line
            ctx.beginPath();
            ctx.moveTo(startX, goalY);
            ctx.lineTo(endX, goalY);
            ctx.stroke();

            // Restore context to default settings
            ctx.restore();
         }
      };

      // Function to calculate dynamic font size for Y-axis title based on screen width
      function getDynamicFontSize() {
         const screenWidth = window.innerWidth;
          
         if (screenWidth < 767) { 
            return 12; // Smaller font size for mobile view
         } else if (screenWidth < 2000)  {
            return 15.7; // Medium font size for tablets
         } else {
            return 18; // Larger font size for desktop view
         }
      }

     function getDynamicFontSizeToolTip() {
         const screenWidth = window.innerWidth;
          
         if (screenWidth < 767) { 
            return 12; // Smaller font size for mobile view
         } else if (screenWidth < 2000)  {
            return 15; // Medium font size for tablets
         } else {
            return 16; // Larger font size for desktop view
         }
      }
      
      const data = {
         labels: weeks,
         datasets: [
            {
               label: 'Semaglutide',
               data: calculateDataPoints(semaglutidePercentageList, formData.weight, weeks, goalWeight),
               borderColor: "rgba(0, 0, 255, 0.9)",
               fill: false,
               tension: 0.4,
               offset: true,
               labelDisplayYOffset: 10,
               labelDisplayXOffset: -5,
               pointBackgroundColor: 'rgba(0, 0, 255, 0.9)', // Color of the data points
               pointRadius: 2,
               borderWidth: 1,

            },
            {
               label: 'Tirzepatide',
               data: calculateDataPoints(tirzepatidePercentageList, formData.weight, weeks, goalWeight),
               borderColor: "rgb(241, 106, 119)",
               fill: false,
               tension: 0.4,
               offset: true,
               labelDisplayYOffset: -25,
               labelDisplayXOffset: 8,
               pointBackgroundColor: 'rgb(241, 106, 119)', // Color of the data points
               pointRadius: 2,
               borderWidth: 1,
            },
            {
               label: `Goal Weight (${goalWeight} lbs)`,
               data: goalWeightData,
               borderColor: 'rgba(162, 72, 87, 0.8)',
               borderWidth: 1,
               borderDash: [10, 5],
               fill: false,
               pointRadius: 0
            }
         ]
      };

      const config = {
         type: 'line',
         data: data,
         options: {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 2,
            plugins: {
               // title: {
               //    display: true,
               //    text: 'Weight Loss Comparison : Semaglutide vs Tirzepatide',
               // },
               legend: {
                  display: false,
                  // labels: {
                  //    boxWidth: 20, // Width of the colored box in the legend
                  //    font: {
                  //       size: 12 // Font size for the legend labels
                  //    },
                  //    generateLabels: function (chart) {
                  //       const original = Chart.defaults.plugins.legend.labels.generateLabels(chart);
                  //       // Customize Goal Weight legend item to remove the box and show only a line
                  //       original.forEach(label => {
                  //          if (label.text === `Goal Weight (${goalWeight} lbs)`) {
                  //             label.fillStyle = 'transparent'; // Remove the fill box
                  //             label.strokeStyle = 'rgba(162, 72, 87, 0.8)'; // Line color
                  //             label.lineWidth = 1; // Line width
                  //             label.borderDash = [10, 5]; // Dashed line style
                  //             label.usePointStyle = false; // Disable point style
                  //          }
                  //       });
                  //       return original;
                  //    }
                  // }
               },
               tooltip: {
                enabled: true,
                callbacks: {
                  title: function(tooltipItems) {
                      const week = tooltipItems[0].label; 
                      return `Week ${week}`;
                   },
                   beforeBody: function(tooltipItems) {
                      const weight = tooltipItems[0].raw.y;
                      return `Est. Weight: ${weight} lbs`;
                   },
                 
                   label: function(context) { 
                      const datasetLabel = context.dataset.label || '';
                      return [
                          `${datasetLabel}`
                      ];
                  },
                  labelColor: function(context) {
                       if (context.dataset.label === 'Semaglutide') {
                          return {
                              backgroundColor: 'rgba(0, 0, 255, 0.6)', // Lighter shade of blue
                              borderColor: 'rgba(0, 0, 255, 0.6)',
                              borderWidth: 0,
                          };
                      } else {
                          return {
                              backgroundColor: context.dataset.borderColor,
                              borderColor: context.dataset.borderColor,
                              borderWidth: 0,
                          };
                      }
                   }
                },
                titleFont: {
                   size: getDynamicFontSizeToolTip(),
                    weight: 'bold'
                },
                bodyFont: {
                   size: getDynamicFontSizeToolTip(),
                },
                footerFont: {
                   size: getDynamicFontSizeToolTip(),
                   weight: 'normal',
                },
                bodySpacing: 6,
                padding: {
                    top: 8,
                    bottom: 10,
                    left: 10,
                    right: 15
                  },
                boxPadding: 5,
                boxWidth: 16,
                boxHeight: 13 
             }
            },
            interaction: {
               intersect: false,
            },
            scales: {
               x: {
                  display: true,
                  title: {
                     display: true,
                     text: 'Weeks',
                     font: {
                        size: getDynamicFontSize(),// Dynamic font size for Y-axis title
                        weight: "bold"
                     }
                  },
                  offset: true,
                  ticks: {
                     font: function(context) {
                       //let width = context.chart.width;
                       const screenWidth = window.innerWidth;
                        if (screenWidth < 767) {
                           return { size: 12 }; // Smaller font size on small screens
                        } else if (screenWidth < 2000) {
                           return { size: 16 }; // medium font on width < 2000 screens
                        } else {
                           return { size: 20 }; // Larger font on bigger screens
                        }
                     }
                   }
               },
               y: {
                  display: true,
                  title: {
                     display: true,
                     text: 'Estimated Weight Loss (lbs)',
                     font: {
                        size: getDynamicFontSize(), // Dynamic font size for Y-axis title
                        weight: "bold"
                     }
                  },
                  offset: true,
                  beginAtZero: false,
                  ticks: {
                     font: function(context) {
                       //let width = context.chart.width;
                       const screenWidth = window.innerWidth;
                       if (screenWidth < 767) {
                           return { size: 12 }; // Smaller font size on small screens
                        } else if (screenWidth < 2000) {
                           return { size: 16 }; // medium font on width < 2000 screens
                        } else {
                           return { size: 20 }; // Larger font on bigger screens
                        }
                     }
                   }
               }
            }
         },
         plugins: [customLabelPlugin, chartBackgroundPlugin, startingWeightLabelPlugin, dashedLinePlugin]
      };

      var chart = new Chart(ctx, config);
   }

});

/* END weight loss chart js */